// modules
import React, { PureComponent } from 'react';
import classnames from 'classnames';

// aliased
import Header from 'components/Header';
import ContactButton from 'components/ContactButton';
import DsdSection from 'components/DsdSection';
import AboutSection from 'components/AboutSection';
import ConditionsSection from 'components/ConditionsSection';
import StonesSection from 'components/StonesSection';
import RoboticsSection from 'components/RoboticsSection';
import Footer from 'components/Footer';
import StethescopeIcon from 'components/StethoscopeIcon';
// import DsdIcon from 'components/DsdIcon';
import KidneyIcon from 'components/KidneyIcon';
import NewsIcon from 'components/NewsIcon';
import RobotIcon from 'components/RobotIcon';
import NewsSection from 'components/NewsSection';

// icons
import about from 'icons/about.svg';
import gender from 'icons/gender-symbol.svg';

// local
import styles from './HomeView.pcss';

// const links = [
//   {
//     to: 'https://www.pdxmonthly.com/doctors/casey-allison-seideman',
//     children: 'Voted "Top Doctor" by Portland Monthly 2018',
//   },
// ];

// https://news.ohsu.edu/2017/07/12/its-all-in-the-wrists-using-robotic-surgery-to-cure-a-life-long-condition
// https://blogs.ohsu.edu/doernbecher/2017/03/29/doctors-day-qa-with-dr-casey-seideman/
// https://www.pdxmonthly.com/doctors/casey-allison-seideman
// https://www.instagram.com/p/BfG7hI8hPhn/?taken-by=ohsudoernbecher
// https://www.instagram.com/p/BWdKOgWBGFG/?taken-by=ohsudoernbecher
// https://www.instagram.com/p/BSzaR27hpKj/?taken-by=ohsudoernbecher
// https://blogs.ohsu.edu/doernbecher/2017/09/28/how-to-beat-bedwetting/

const LINKS = [
  {
    to: '/about',
    children: 'about',
    name: 'about',
    icon: about,
  },
  {
    to: '/conditions',
    children: 'conditions',
    name: 'conditions',
    icon: (
      <StethescopeIcon />
    ),
  },
  {
    to: '/dsd',
    children: 'dsd',
    name: 'dsd',
    icon: gender,
  },
  {
    to: '/robotics',
    children: 'robotics',
    name: 'robotics',
    icon: (<RobotIcon />),
  },
  {
    to: '/stones',
    children: 'stones',
    name: 'stones',
    icon: (<KidneyIcon  />),
  },
  {
    to: '/news',
    children: 'news',
    name: 'news',
    icon: (<NewsIcon  />),
  },
];

export default class HomeView extends PureComponent {
  
  static propTypes = {}
  static defaultProps = {}
  
  state = {
    menuActive: false,
  }
  
  handleToggleMenu = (menuActive = !this.state.menuActive) => {
    this.setState({ menuActive });
  }

  render() {
    const { menuActive } = this.state;
    
    const classNames = classnames(styles.homeView);
      
    return (
      <div className={ classNames }>
        <Header
          links={ LINKS }
          onToggleMenu={ this.handleToggleMenu }
          menuActive={ menuActive } />
        <AboutSection />
        <ConditionsSection />
        <DsdSection />
        <RoboticsSection />
        <StonesSection />
        <NewsSection />
        <ContactButton className={ styles.contactButton } />
        <Footer />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/views/HomeView/index.jsx